
const angular = require('angular')
const _ = require('lodash')
import * as oauthHandshake from '../../../services/session/oauthHandshake'
import { PERMISSION_REVIEW_RESPONSES } from '../../../services/session/oauthHandshake'
import presignedExport from '../../../services/auth/presignedExport';

angular.module('clientDashboardApp.admin').controller('CredentialsListController',
  function(
    $scope, $state, $uibModal,
    credentialService, locationService, confirmService, pagingService,
    reviewResponseConfiguration, $timeout
  ) {
  let vm = this
  vm.initialized = false
  vm.providers = {}
  vm.addProviderLinks = []
  vm.filters = {
    sortField: 'remoteAccountNameLowercase',
    sortOrder: 'ASC'
  }

  const defaultPagination = Object.freeze({
    page: 1,
    pageSize: 15,
    list: undefined,
    total: undefined,
    isLoadingPage: true,
    isLoadingCount: true
  })
  vm.pagination = {...defaultPagination}

  function refreshCredentials() {
    const lastPage = vm.pagination.page;
    vm.pagination = {
      ...defaultPagination
    };
    credentialService.countCredentials({})
      .then(total => {
        const pageSize = vm.pagination.pageSize;
        vm.pagination.total = total;
        vm.pagination.isLoadingCount = false;
        vm.pagination.page = (lastPage - 1) * pageSize > total ? Math.ceil(total / pageSize) : lastPage;
        return loadPage()
      })
  }

  function loadPage() {
    vm.pagination.isLoadingPage = true;
    vm.list = undefined;
    credentialService.searchCredentials({
      ...vm.filters,
      offset: (vm.pagination.page - 1) * vm.pagination.pageSize,
      limit: vm.pagination.pageSize
    }).then(credentials => {
      vm.pagination.list = credentials;
      vm.pagination.isLoadingPage = false;
    })
  }
  vm.loadPage = loadPage

  vm.setPage = pageIndex => {
    vm.pagination.page = pageIndex;
    loadPage()
  }

  vm.showErrors = $state.params.showErrors

  vm.addCredential = function(provider) {
    if (provider.providerSettings.supportsOauth) {
      oauthHandshake.requestUserAccessFromProvider(provider.name, [PERMISSION_REVIEW_RESPONSES]).then(token => {
        refreshCredentials()
      })
    }
    else {
      $uibModal.open({
        template: require('./userPasswordCredentialModal.html'),
        scope: $scope,
        controller: ["$scope", UserPasswordModalCtrl(provider, onAddCredential, credentialService)],
        controllerAs: 'vm'
      })
    }
  }

  vm.getLoadListingsFunction = (credentialId) => {
    return (page, pageSize) => {
      const offset = ((page || 1)-1) * pageSize;
      return credentialService.listingsForCredential({credentialId, offset, limit: pageSize})
    }
  };

  vm.viewCredentialDetails = credentialResult => {
    $uibModal.open({
      template: require('./credentialDetailsModal.html'),
      scope: $scope,
      controller: ["$scope", CredentialModalCtrl(
        credentialResult.credential.remoteAccountName,
        credentialResult.listingCount,
        vm.getLoadListingsFunction(credentialResult.credential._id),
        10,
        "Associated Listings"
      )],
      controllerAs: 'vm',
      size: "xl"
    })
  }

  let listingsMissingCredentials = {}; // listings missing credentials are shared within a provider
  vm.getMissingListingsForProvider = (provider) => {
    return (page, pageSize) => {
      const offset = ((page || 1)-1) * pageSize;
      const listings = listingsMissingCredentials[provider].slice(offset, offset+pageSize);
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(listings);
        }, -1);
      });
    }
  };

  vm.viewMissingCredentialDetails = credentialResult => {
    if (credentialResult.loadingMissingListings) {
      return;
    }
    let providerName = credentialResult.credential.provider;
    const open = () => {
      const count = listingsMissingCredentials[providerName].length;
      $uibModal.open({
        template: require('./credentialDetailsModal.html'),
        scope: $scope,
        controller: ["$scope", CredentialModalCtrl(
          credentialResult.credential.remoteAccountName,
          count,
          vm.getMissingListingsForProvider(providerName),
          count,
          providerName + " Listings Unassociated to any Credential"
        )],
        controllerAs: 'vm',
        size: "xl"
      })
    }
    if (providerName in listingsMissingCredentials) {
      open()
    } else {
      credentialResult.loadingMissingListings = true;
      credentialService.listingsMissingCredentials(providerName)
        .then(x => {
          credentialResult.loadingMissingListings = false;
          listingsMissingCredentials[providerName] = x
          open()
        })
    }
  }


  vm.deleteCredential = credentialResult => {
    confirmService.confirm("Remove Account Access?", "This will remove access to your external account - you will be unable to respond to reviews managed by this account.", confirmService.DELETE)
      .then(confirmed => {
        if (confirmed) {
          credentialService.deleteCredential(credentialResult.credential._id)
          refreshCredentials()
        }
      })
  }

  vm.updateRemoteResourceList = credentialResult => {
    confirmService.confirm("Refresh Associated Locations?", "This may affect listings and reviews for this provider.", confirmService.WARNING)
      .then(confirmed => {
        if (confirmed) {
          credentialService.updateRemoteResourceList(credentialResult.credential._id)
            .then(x => loadPage())

        }
      })
  }

  vm.preparingExport = false
  vm.exportCredentialReport = function() {
    vm.preparingExport = true
    presignedExport.downloadExport("/v5/credentials/report" )
    $timeout(() => vm.preparingExport = false, 10000)
  }


  function onAddCredential(credential) {
    vm.credentials.push({credential: credential, listings: []});
    refreshCredentials()
  }

  const CredentialModalCtrl = (
    remoteAccountName,
    listingCount,
    getListingsPage,
    limit,
    title) => function ($scope) {

    const vm = this;
    vm.listingsPageLimit = limit;
    vm.listingsPage = listingCount > 0 ? 1: 0;
    vm.totalListings = listingCount;
    vm.getPage = () => {
      vm.listings = [];
      vm.listingsLoading = true;
      getListingsPage(vm.listingsPage, vm.listingsPageLimit).then( x => {
        vm.listings = x;
        vm.listingsLoading = false;
      })
    };
    vm.getPage(vm.listingsPage);
    vm.remoteAccountName = remoteAccountName;
    vm.title = title;
  }

  const UserPasswordModalCtrl = (provider, onAddCalleback, credentialService) => function ($scope) {
    const vm = this;
    vm.provider = provider

    vm.saveCredential = () => {
      credentialService.saveCredential(provider.id, vm.externalUsername, vm.externalPassword).then(credential => {
        $scope.$close()
        onAddCalleback(credential)
      })
    }
  }
  // init
  reviewResponseConfiguration.listReviewResponseCredentialProviders().then(providers => {
    vm.providers = providers.reduce((sum, x) => ({...sum, [x.id]: x}), {});
    vm.addProviderLinks = providers.slice()
    vm.providers["GOOGLEMAP"] = vm.providers["GOOGLE"]   // I'm not proud of this
    refreshCredentials()
  });


})
